/**
 * @author PoornaChandu
 */
import React, { Fragment, useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { message, Form, Button, Input, Select } from 'antd';
import { DatePicker } from 'antd';
import { connect } from 'react-redux';
import { getWarningTypes, getRootCauseInfo } from './Apicalls';
import StyledTable from '../../commons/styles/table';
import constants from './constants';
import history from '../../commons/history';
import { getparameterList } from './Apicalls';
import { CaretLeftOutlined } from '@ant-design/icons';
const { Option } = Select;
const { RangePicker } = DatePicker;
const RootCause = (props) => {
  const [tableData, setTableData] = useState([]);
  const [DeviceId, setDeviceId] = useState('');
  const [parameterList, setParameterList] = useState([]);
  const [ParameterCode, setParameterCode] = useState([]);
  const [WarningType, setWarningType] = useState(['Warning-1', 'Warning-2', 'Warning-3']);
  const [warningLimits, setWarningLimits] = useState([]);
  const [selectedDate, setSelectedDate] = useState({});
  const hRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      let queryString = props.location.search;
      let deviceId = queryString.match(/Device=([^&]*)/i)[1];
      let endTime = queryString.match(/EndTime=([^&]*)/i)[1];
      let parameter = queryString.match(/Parameter=([^&]*)/i)[1];
      let endDate = moment.utc(endTime, 'YYYY-MM-DD HH:mm').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm');
      let selectedDate = {
        startDate: moment(endDate).subtract(1, 'hour').format('YYYY-MM-DD HH:mm'),
        endDate: moment(endDate).format('YYYY-MM-DD HH:mm')
      };
      setDeviceId(deviceId);
      setParameterCode([parameter]);
      setSelectedDate(selectedDate);
      try {
        let warningLimitsData = await getWarningTypes();
        let paramList = await getparameterList(deviceId, 'Device');
        setParameterList(paramList && paramList.data ? paramList.data : []);
        setWarningLimits(warningLimitsData && warningLimitsData.data ? warningLimitsData.data : []);
        await getRootCauseInfo({ DeviceId: deviceId, ParameterCode: [parameter], selectedDate });
      } catch (error) {
        message.error(error);
      }
    };
    fetchData();
  }, [props.location.search, props.currentTimeZone]);
  const multiSelectHandle = (value, type) => {
    if (type === 'ParameterCode') {
      setParameterCode(value);
    } else if (type === 'WarningType') {
      setWarningType(value);
    }
  };
  const onChange = (value) => {
    setSelectedDate({
      startDate: moment(value[0]).format('YYYY-MM-DD HH:mm'),
      endDate: moment(value[1]).format('YYYY-MM-DD HH:mm')
    });
  };
  const handleSubmit = async () => {
    hRef.current
      .validateFields()
      .then(async () => {
        try {
          let rootCauseList = await getRootCauseInfo({ DeviceId, ParameterCode, selectedDate });
          setTableData(rootCauseList.data);
        } catch (error) {
          message.error(error.response.data.message);
        }
      })
      .catch(() => { });
  };
  const columns = [
    {
      title: 'Created Time',
      dataIndex: 'CREATEDTIME',
      key: 'CREATEDTIME'
    },
    {
      title: 'Warning Type',
      dataIndex: 'WarningType',
      key: 'WarningType'
    },
    {
      title: 'Parameter',
      dataIndex: 'Parameter',
      key: 'Parameter'
    },
    {
      title: 'Value',
      dataIndex: 'Value',
      key: 'Value'
    }
  ];
  return (
      <Fragment>
        <Button
          type="primary"
          style={{ marginBottom: '10px' }}
          onClick={() => {
            history.goBack();
          }}
        >
          <CaretLeftOutlined />{' '}
          {props.translationCache && props.translationCache[`${constants.Go_Back}`]
            ? props.translationCache[`${constants.Go_Back}`]
            : `${constants.Go_Back}`}{' '}
        </Button>
        <Form layout="inline" ref={hRef} initialValues={{ DeviceId, ParameterCode, WarningType }}>
          <Form.Item
            name="DeviceId"
            rules={[{ required: true, message: 'Please input your username!' }]}
          >
            <Input value={DeviceId} disabled placeholder="Device ID" />
          </Form.Item>
          <Form.Item
            name="ParameterCode"
            rules={[{ required: true, message: 'Please Select Parameters' }]}
          >
            <Select
              mode="multiple"
              value={ParameterCode}
              placeholder="Select ParameterList"
              style={{ width: '500px' }}
              onChange={(e) => multiSelectHandle(e, 'ParameterCode')}
            >
              {parameterList.map((param, index) => (
                <Option key={index} value={param.ParameterCode}>
                  {param.ParameterCode}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="WarningType"
            rules={[{ required: true, message: 'Please Select Warning Type' }]}
          >
            <Select
              mode="multiple"
              value={WarningType}
              placeholder="Select Warning Type"
              style={{ width: '500px' }}
              onChange={(e) => multiSelectHandle(e, 'WarningType')}
            >
              {warningLimits.map((param, index) => (
                <Option key={index} value={param.WarningType}>
                  {param.WarningType}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item>
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              style={{ width: '300px', float: 'right' }}
              format="YYYY-MM-DD HH:mm"
              value={[moment(selectedDate.startDate), moment(selectedDate.endDate)]}
              onChange={onChange}
              disabledDate={(current) => current > moment().endOf('day')}
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </Form.Item>
        </Form>
        <div>
          <StyledTable size="small"
            style={{ marginTop: '3%' }}
            columns={columns}
            dataSource={tableData}
          />
        </div>
      </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(RootCause);
